export default "__VITE_ASSET__mUvVLYqf__"